var _excluded = ["onClick", "to", "href", "arrowDirection", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { shouldForwardProp } from '../../utils';
import SmartLink from '../../componentWrappers/SmartLink';

/* babel-plugin-inline-import '../../assets/arrow.svg' */
var arrow = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEzIiB2aWV3Qm94PSIwIDAgOCAxMyI+CiAgICA8cGF0aCBmaWxsPSIjYjhiOGI4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjQ4NC42bDYgNi02IDYtMS40MTYtMS40MTZMNC42NzYgNi42LjA2OCAyLjAxNnoiLz4KPC9zdmc+Cg==";
import { strictSpace } from '../../utils';

var flexContainerStyles = function flexContainerStyles(_ref) {
  var theme = _ref.theme;
  return "\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: flex-start;\n";
};

var StyledImg = styled.img.withConfig({
  displayName: "SemanticContainer__StyledImg",
  componentId: "sc-1jjbth4-0"
})(["display:block;position:absolute;right:", ";top:50%;transform:translateY(-50%) rotate(", ");height:", ";width:", ";z-index:1;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.s;
}, function (props) {
  return convertToDeg(props.arrowDirection);
}, function (props) {
  return props.theme.space.xs;
}, function (props) {
  return props.theme.space.xs;
});
var FlexContainer = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "SemanticContainer__FlexContainer",
  componentId: "sc-1jjbth4-1"
})(["", " ", ";"], flexContainerStyles, strictSpace);
FlexContainer.defaultProps = {
  p: 's'
};
var InteractiveFlexContainer = styled(SmartLink).withConfig({
  displayName: "SemanticContainer__InteractiveFlexContainer",
  componentId: "sc-1jjbth4-2"
})(["", " width:calc(100% - ", ");&::after{content:'';width:", ";position:absolute;top:0;bottom:0;right:0;transition:0.2s background-color;z-index:0;}border-radius:4px;text-align:left;appearance:none;background:none;border:0;transition:0.2s background-color;text-decoration:none;&:hover,&:focus{text-decoration:none;background-color:", ";&::after{background-color:", ";}}", ";"], flexContainerStyles, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.m;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.m;
}, function (props) {
  return props.theme.colors.bgSecondary;
}, function (props) {
  return props.theme.colors.bgSecondary;
}, strictSpace);
InteractiveFlexContainer.defaultProps = {
  p: 's'
};

var convertToDeg = function convertToDeg(props) {
  switch (props) {
    case 'right':
      return '0deg';

    case 'down':
      return '90deg';

    case 'left':
      return '-180deg';

    case 'up':
      return '-90deg';

    default:
      return '0deg';
  }
};

var SemanticContainer = function SemanticContainer(_ref5) {
  var _StyledImg;

  var onClick = _ref5.onClick,
      to = _ref5.to,
      href = _ref5.href,
      arrowDirection = _ref5.arrowDirection,
      children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded);

  if (to || href || onClick) {
    return /*#__PURE__*/React.createElement(InteractiveFlexContainer, _extends({
      to: to,
      href: href,
      onClick: onClick
    }, rest), children, " ", _StyledImg || (_StyledImg = /*#__PURE__*/React.createElement(StyledImg, {
      arrowDirection: arrowDirection,
      alt: "",
      src: arrow
    })));
  }

  return /*#__PURE__*/React.createElement(FlexContainer, rest, children);
};

export default SemanticContainer;